import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/stat-customer'

export async function statByDate(params) {
    const query = stringify(params)
    return request(`${api.statByDate.url}${query ? `?${query}` : ''}`)
}

export async function statByUser(params) {
    const query = stringify(params)
    return request(`${api.statByUser.url}${query ? `?${query}` : ''}`)
}

export async function exportStatByDate(params) {
    const query = stringify(params)
    return request(`${api.exportStatByDate.url}${query ? `?${query}` : ''}`, null, {
        returnResponse: true,
    })
}

export async function exportStatByUser(params) {
    const query = stringify(params)
    return request(`${api.exportStatByUser.url}${query ? `?${query}` : ''}`, null, {
        returnResponse: true,
    })
}
